
export default {
  name: 'HCheckbox',
  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    inputValue: {
      type: [Array, String, Boolean],
      default: '',
    },
    value: {
      type: [Array, String, Boolean],
      default: '',
    },
    indeterminate: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    hasError: {
      type: Boolean,
    },
    hideDetails: {
      type: [Boolean, String],
      default: true,
    },
    dense: {
      type: Boolean,
    },
    compress: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
  },
  methods: {
    bubbleEvent(val) {
      this.$emit('input', val || false);
    },
  },
};
